<template>
  <section class="program-detal-content" v-if="program">
    <div class="columns">
      <div class="column is-9-desktop is-12-tablet is-12-mobile">
        <div class="program-detal-content__description">
          <photo-loader
            :image="program.image"
            height-skeletor="465px"
            :imgWidth="program?.image?.width"
            :imgHeight="program?.image?.height"
          />
          <p class="program-detal-content__text" v-if="program.description">
            {{ program.description }}
          </p>
        </div>
      </div>
      <div class="column is-3-desktop is-12-tablet is-12-mobile">
        <div class="program-detal-content__other-transmission" v-if="otherEmissions?.length">
          <p class="program-detal-content__headline">Pozostałe emisje</p>
          <app-link
            v-for="(item, key) in otherEmissions"
            class="program-detal-content__box"
            :to="item.url"
            :path-type="item.type"
            :routing-data="item.routing_data"
            :key="key"
          >
            <div
              class="program-detal-content__station"
              :style="`background-color: ${item.station.logoBackgroundColor};`"
            >
              <img :src="item.station.logoSrc" :alt="item.station.name" />
            </div>
            <div class="program-detal-content__info">
              <span class="program-detal-content__info-day"
                >Dziś, {{ formatDayTvProgram(Date()) }},</span
              >
              <span class="program-detal-content__info-day">{{ formatDateTvProgram(Date()) }}</span>
              <span class="program-detal-content__info-hour">
                {{ formatDateToTime(item.date_start) }}</span
              >
            </div>
          </app-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import PhotoLoader from '@/components/elements/PhotoLoader.vue'
import AppLink from '@/components/layout/AppLink.vue'
import { useUtils } from '@/composables/useUtils'

const { formatDateTvProgram, formatDayTvProgram, formatDateToTime } = useUtils()

defineProps({
  program: {
    type: Object,
    default: () => ({})
  },
  otherEmissions: {
    type: Array,
    default: () => []
  }
})
</script>

<style lang="scss">
@import '@/assets/scss/components/program/program-tv-detail-content.scss';
</style>
